import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  GetLoyaltyTiersByBrandRequest,
  LoyaltyConstantTier,
  LoyaltyDerivedTier,
} from "../../gen/witbooking/backoffice/loyalty/tier/v1/loyalty_tier_api_pb";
import * as TableRenderers from "../shared/renderers/table";
import { mapRenderer, StringRenderer } from "../shared/renderers/table";
import { v4 as uuidv4 } from "uuid";
import { FormConfiguration } from "../shared/crud/form";
import SimpleCrud, { defaultCrudMessages } from "../shared/crud/simple-crud";

import { FormContainer } from "./form-style";
import schema from "../../gen/schema/witbooking.loyalty.organization.v1/Organization.json";
import { useGrpcClient } from "../../lib/grpc";
import { defineMessage, defineMessages, FormattedMessage, useIntl } from "react-intl";
import actions from "../../lib/actions";
import { withAuthorizationVerifier } from "../../components/authorization-verifier";
import { SECTION } from "../../lib/constants";
import { LoyaltyTierAPIPromiseClient } from "../../gen/witbooking/backoffice/loyalty/tier/v1/loyalty_tier_api_grpc_web_pb";
import { TableColumns, TableFilters } from "../shared/crud/list";
import { inputFilter, selectorFilter } from "../shared/crud/filter-widgets";
import { CountrySelector } from "../shared/widgets/countrySelector";
import { RendererProps } from "../shared/renderers";
import {
  DefaultTableRowActionsProps,
  Edit,
  StyledReactTooltip,
} from "../shared/actions/tableActions";
import { useHistory, useRouteMatch } from "react-router";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IPropertyLoyaltyBrand, useLoyaltyBrand } from "../../components/loyalty-brand-provider";
import { Localizable } from "../../gen/witbooking/backoffice/common/common_pb";
import { ArrayAsString } from "../shared/widgets/arrayAsString";
import {
  Agency,
  Company,
  CreateOrganizationRequest,
  FindOrganizationsRequest,
  GetOrganizationRequest,
  Organization,
  UpdateOrganizationRequest,
} from "../../gen/witbooking/loyalty/organization/v1/organization_api_pb";
import { OrganizationAPIPromiseClient } from "../../gen/witbooking/loyalty/organization/v1/organization_api_grpc_web_pb";
import { faLink, faUsers } from "@fortawesome/free-solid-svg-icons";
import { useLocaleProvider } from "../../components/locale-provider";
import { LoyaltyConstantTierSelectorMulti } from "../shared/widgets/loyaltyConstantTierSelectorMulti";
import { OrganizationType } from "../shared/widgets/organizationType";
import styled from "styled-components";
import { ORGANIZATION_TYPE } from "../witadmin/Common/constants";

import { Table } from "@devexpress/dx-react-grid-bootstrap4";

const organizationMessages = defineMessages({
  entityName: {
    id: "loyaltyOrganization.entityName",
    defaultMessage: "Organizations",
  },
  edit: {
    id: "loyaltyCustomer.edit",
    defaultMessage: "edit",
  },
  customers: {
    id: "loyaltyOrganization.customers",
    defaultMessage: "customers",
  },
  register: {
    id: "loyaltyOrganization.register",
    defaultMessage: "register",
  },
  modalText1: {
    id: "loyaltyOrganization.modalText1",
    defaultMessage: "modalText1",
  },
  modalText2: {
    id: "loyaltyOrganization.modalText2",
    defaultMessage: "modalText2",
  },
  copy: {
    id: "loyaltyOrganization.copy",
    defaultMessage: "copy",
  },
});

const tableHeaderMessages = defineMessages({
  id: { id: "loyaltyOrganization.id", defaultMessage: "Company id" },
  ticker: { id: "loyaltyOrganization.ticker", defaultMessage: "Ticker" },
  name: { id: "loyaltyOrganization.name", defaultMessage: "Comany name " },
  legalIdentifier: { id: "loyaltyOrganization.legalIdentifier", defaultMessage: "Legal id" },
  tagsList: { id: "loyaltyOrganization.tagsList", defaultMessage: "Company tags" },
  idHelpText: { id: "loyaltyOrganization.idHelpText", defaultMessage: "Autogenerated company id" },
  tiersList: { id: "loyaltyOrganization.tiersList", defaultMessage: "Enabled tiers" },
  tickerHelpText: {
    id: "loyaltyOrganization.tickerHelpText",
    defaultMessage: "Short name (max 12 char.) no spaces allowed.",
  },
  country: { id: "loyaltyOrganization.country", defaultMessage: "Country" },
  nameHelpText: { id: "loyaltyOrganization.nameHelpText", defaultMessage: "Company legal name" },
  address: { id: "loyaltyOrganization.address", defaultMessage: "Address" },
  legalIdentifierHelpText: {
    id: "loyaltyOrganization.legalIdentifierHelpText",
    defaultMessage: "Legal id of the company",
  },
  city: { id: "loyaltyOrganization.city", defaultMessage: "City" },
  tagsListHelpText: {
    id: "loyaltyOrganization.tagsListHelpText",
    defaultMessage: "Allows user segmentation",
  },
  zipCode: { id: "loyaltyOrganization.zipCode", defaultMessage: "Zip Code" },
  phoneNumber: { id: "loyaltyOrganization.phoneNumber", defaultMessage: "phoneNumber" },
  emailAddress: { id: "loyaltyOrganization.emailAddress", defaultMessage: "emailAddress" },
  organizationType: { id: "loyaltyOrganization.organizationType", defaultMessage: "Type" },
  iata: { id: "loyaltyOrganization.iata", defaultMessage: "iata" },
  tiersListHelpText: {
    id: "loyaltyOrganization.tiersListHelpText",
    defaultMessage: "The users of this company may only be assigned to the these tiers.",
  },
  "location.country": { id: "loyaltyOrganization.country", defaultMessage: "Country" },
  "location.city": { id: "loyaltyOrganization.city", defaultMessage: "City" },
  "location.address": { id: "loyaltyOrganization.address", defaultMessage: "Address" },
  "location.zipCode": { id: "loyaltyOrganization.zipCode", defaultMessage: "ZipCode" },
});

const messages = {
  ...defaultCrudMessages,
  ...organizationMessages,
  patternValidationFailed: {
    ".ticker": defineMessage({
      id: "loyaltyTier.tickerPatternFailed",
      defaultMessage: "Must be uppercase. Doesn't allow blank spaces or special characters",
    }),
  },
  tableHeaders: tableHeaderMessages,
  deleteDisabledDescription: defineMessage({
    id: "loyaltyTier.deleteDisabledDescription",
    defaultMessage: "This loyalty tier has linked inventory lines, so it can't be deleted.",
  }),
  agency: { id: "loyaltyOrganization.agency", defaultMessage: "agency" },
  company: { id: "loyaltyOrganization.company", defaultMessage: "company" },
};

const Copy = styled.div`
  text-align: left;
  cursor: pointer;
  text-decoration: underline;
`;

const Tier = styled.div`
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 1rem;
  word-break: break-all;
`;

interface OrganizationFilters {
  id: string;
  brandId: string;
  ticker: string;
  name: string;
  legalIdentifier: string;
  tagsList: string;
  tiersList: string;
  phoneNumber: string;
  emailAddress: string;
}

interface OrganizationWithType extends Organization.AsObject {
  organizationType?: { organizationType?: string; iata?: string };
  iata?: string;
}

let modifiedSchema = schema;

//Schema generates incorrectly for proto.google.protobuf.Timestamp() and causes validate error
// @ts-ignore
modifiedSchema.properties.createdAt.type = "object";
// @ts-ignore
modifiedSchema.properties.updatedAt.type = "object";
// @ts-ignore
modifiedSchema.properties.organizationType = {
  properties: {
    organizationType: {
      type: "string",
    },
    iata: {
      type: "string",
    },
  },
  type: "object",
};

function organizationFromObject(obj: OrganizationWithType, brandId: string): Organization {
  const localizable = new Localizable();
  localizable.setCountry(obj?.location?.country || "AF");
  localizable.setCity(obj.location!!.city);
  localizable.setAddress(obj.location!!.address);
  localizable.setZipCode(obj.location!!.zipCode);

  const result = new Organization();
  result.setId(obj.id);
  result.setBrandId(brandId);
  result.setTicker(obj.ticker);
  result.setName(obj.name);
  result.setDescription(obj.description);
  result.setLegalIdentifier(obj.legalIdentifier);
  const company = new Company();
  result.setCompany(company);
  const agency = new Agency();
  result.setAgency(agency);
  result.setTagsList(obj.tagsList);
  result.setTiersList(obj.tiersList);
  result.setLocation(localizable);
  // @ts-ignore
  const createdAt = new proto.google.protobuf.Timestamp();
  createdAt.setNanos(obj.createdAt?.nanos);
  createdAt.setSeconds(obj.createdAt?.seconds);
  result.setCreatedAt(createdAt);
  // @ts-ignore
  const updatedAt = new proto.google.protobuf.Timestamp();
  updatedAt.setNanos(obj.updatedAt?.nanos);
  updatedAt.setSeconds(obj.updatedAt?.seconds);
  result.setInUse(obj.inUse);
  result.setPhoneNumber(obj.phoneNumber);
  result.setEmailAddress(obj.emailAddress);
  result.setUpdatedAt(updatedAt);
  result.setLegalIdentifier(obj.legalIdentifier);
  if (obj.organizationType?.organizationType === ORGANIZATION_TYPE.COMPANY) {
    const company = new Company();
    result.setCompany(company);
  } else {
    const agency = new Agency();
    if (obj.organizationType?.iata) {
      agency.setIata(obj.organizationType?.iata);
    }
    result.setAgency(agency);
  }

  return result;
}

const filters = [
  "ticker",
  "name",
  "legalIdentifier",
  "phoneNumber",
  "emailAddress",
  "tagsList",
  "tiersList",
  "location.country",
  "location.city",
  "location.address",
  "location.zipCode",
  "iata",
];

const tableFilters: TableFilters<any, any> = filters.reduce(
  (accum, curr) => ({
    ...accum,
    [curr]: {
      filterFn: "async",
      widget: inputFilter,
    },
  }),
  {}
);

const columnVisibilityExtensions = ["name", "lastName", "emailAddress", "tier"].map(it => ({
  columnName: it,
  togglingEnabled: false,
}));

const defaultPageSize = 50;
const pageSizes = [50, 100, 500];

function LoyaltyOrganizationCrud({ propertyTicker }: { propertyTicker: string }) {
  const client = useGrpcClient(OrganizationAPIPromiseClient);
  const tierClient = useGrpcClient(LoyaltyTierAPIPromiseClient);
  const brandInfo: IPropertyLoyaltyBrand | undefined | null = useLoyaltyBrand();
  const loyaltyDomain =
    brandInfo && brandInfo.mainDomain ? brandInfo.mainDomain : "engine.witbooking.com";
  const authorizationServiceDomain =
    brandInfo?.authorizationServiceDomain ?? "auth-loyalty.witbooking.com";

  const brand = useLoyaltyBrand()?.ticker || "";
  const brandId = useLoyaltyBrand()?.externalSystemId || "";
  const match = useRouteMatch();
  const history = useHistory();
  const locale = useLocaleProvider().currentLocale?.substring(0, 2);
  const intl = useIntl();

  const [registerModalParams, setRegisterModalParams] = useState<{
    tiers: { url: string; urlShort: string; tierTicker: string }[];
    organization: string;
  }>();
  const [modalOpen, setModalOpen] = useState(false);
  const [constantTiers, setConstantTiers] = useState<
    (LoyaltyConstantTier.AsObject | LoyaltyDerivedTier.AsObject | undefined)[] | undefined
  >();

  useEffect(() => {
    tableFilters.type = {
      filterFn: "async",
      widget: selectorFilter(<FormattedMessage {...messages.tableHeaders?.organizationType} />, [
        { value: ORGANIZATION_TYPE.AGENCY, label: intl.formatMessage(messages.agency) },
        { value: ORGANIZATION_TYPE.COMPANY, label: intl.formatMessage(messages.company) },
      ]),
    };
  }, [intl]);

  useEffect(() => {
    const asyncFun = async () => {
      if (!constantTiers && brand) {
        const request = new GetLoyaltyTiersByBrandRequest();
        request.setBrandTicker(brand);
        const response = await tierClient.getLoyaltyTiersByBrand(request);
        if (response) {
          const res = response.toObject();
          setConstantTiers(res.tiersList.map(it => it.constantTier).filter(it => it));
        }
      }
    };
    asyncFun();
  }, [client, constantTiers, brand, tierClient]);

  const onGetAll = useCallback(
    async ({ filterValues, currentPage, pageSize, setTotalRowsCount }) => {
      if (brandId) {
        const request = new FindOrganizationsRequest();
        request.setPageSize(pageSize);
        request.setPageNumber(currentPage);
        request.setBrandId(brandId);

        if (typeof filterValues === "object") {
          interface SelectObject {
            value?: string;
            label?: string;
          }
          Object.entries(filterValues).forEach(([key, value]: [string, unknown | SelectObject]) => {
            if (key === "type" && typeof value === "object" && value) {
              request.getFiltersMap().set(key, (value as SelectObject).value);
            } else if (key !== "tierType") {
              request.getFiltersMap().set(key, value);
            }
          });
        }

        const response = await client.findOrganizations(request);

        setTotalRowsCount(response.getTotalElements());

        const responseObj = response
          .getOrganizationsList()
          .map(m => m.toObject() as OrganizationWithType);
        responseObj.forEach(organization => {
          organization.organizationType = organization.agency
            ? { organizationType: ORGANIZATION_TYPE.AGENCY, iata: organization.agency.iata }
            : { organizationType: ORGANIZATION_TYPE.COMPANY };
        });
        return responseObj;
      }
    },
    [client, brandId]
  );

  const onGetOne = useCallback(
    async id => {
      const request = new GetOrganizationRequest();
      request.setId(id);
      request.setBrandId(brandId);
      const response = (await client.getOrganization(request)).getOrganization();
      if (response) {
        const responseObj = response.toObject() as OrganizationWithType;
        responseObj.organizationType = responseObj.agency
          ? { organizationType: ORGANIZATION_TYPE.AGENCY, iata: responseObj.agency.iata }
          : { organizationType: ORGANIZATION_TYPE.COMPANY };
        return responseObj;
      } else throw new Error("Unexpected reply obtaining organization");
    },
    [client, brandId]
  );

  const onUpdate: (entity: Organization.AsObject) => Promise<void> = useCallback(
    async entity => {
      const organization = organizationFromObject(entity, brandId);
      const request = new UpdateOrganizationRequest();
      request.setOrganization(organization);
      await client.updateOrganization(request);
    },
    [client, brandId]
  );

  const onCreate: (entity: Organization.AsObject) => void = useCallback(
    async entity => {
      const organization = organizationFromObject(entity, brandId);
      const request = new CreateOrganizationRequest();
      request.setOrganization(organization);
      await client.createOrganization(request);
    },
    [client, brandId]
  );

  const TierListRenderer = useCallback(
    ({ value, config, button, rows }: RendererProps<Array<string> | undefined>) => {
      let tierTickers = "";
      if (value) {
        tierTickers = value
          .map(tierId => constantTiers?.find(it => it?.externalSystemId === tierId)?.ticker)
          .toString();
      }
      return <div>{tierTickers}</div>;
    },
    [constantTiers]
  );

  const CSVRenderers = useMemo(
    () => ({
      country: (values: number, fields: { [key: string]: any }) => {
        return fields?.location?.country;
      },
      city: (values: number, fields: { [key: string]: any }) => {
        return fields?.location?.city;
      },
      address: (values: number, fields: { [key: string]: any }) => {
        return fields?.location?.address;
      },
      zipCode: (values: number, fields: { [key: string]: any }) => {
        return fields?.location?.zipCode;
      },
    }),
    []
  );
  const formConfiguration: FormConfiguration<OrganizationWithType> = useMemo(
    () => ({
      __fieldOrder: [
        "id",
        "ticker",
        "organizationType",
        "name",
        "legalIdentifier",
        "phoneNumber",
        "emailAddress",
        "location",
        "tagsList",
        "tiersList",
        "*",
      ],
      __useProtoStyleArrays: true,
      id: {
        default: () => uuidv4(),
        readonly: true,
        messages: {
          label: defineMessage({
            id: "loyaltyOrganization.id",
            defaultMessage: "id",
          }),
          helpText: defineMessage({
            id: "loyaltyOrganization.idHelpText",
            defaultMessage: "HelpText",
          }),
        },
      },

      createdAt: {
        hidden: true,
      },
      updatedAt: {
        hidden: true,
      },
      inUse: {
        hidden: true,
      },
      brandId: {
        hidden: true,
      },
      company: {
        hidden: true,
      },
      agency: {
        hidden: true,
      },
      description: {
        hidden: true,
      },
      ticker: {
        readonly: isNew => !isNew,
        messages: {
          label: defineMessage({
            id: "loyaltyOrganization.ticker",
            defaultMessage: "ticker",
          }),
          helpText: defineMessage({
            id: "loyaltyOrganization.tickerHelpText",
            defaultMessage: "HelpText",
          }),
        },
      },
      organizationType: {
        fieldWidget: OrganizationType,
      },
      name: {
        messages: {
          label: defineMessage({
            id: "loyaltyOrganization.nameLong",
            defaultMessage: "name",
          }),
          helpText: defineMessage({
            id: "loyaltyOrganization.nameHelpText",
            defaultMessage: "HelpText",
          }),
        },
      },
      legalIdentifier: {
        messages: {
          label: defineMessage({
            id: "loyaltyOrganization.legalIdentifierLong",
            defaultMessage: "legalIdentifier",
          }),
          helpText: defineMessage({
            id: "loyaltyOrganization.legalIdentifierHelpText",
            defaultMessage: "HelpText",
          }),
        },
      },
      phoneNumber: {
        messages: {
          label: defineMessage({
            id: "loyaltyOrganization.phoneNumber",
            defaultMessage: "phoneNumber",
          }),
          helpText: defineMessage({
            id: "loyaltyOrganization.phoneNumberHelpText",
            defaultMessage: "HelpText",
          }),
        },
      },
      emailAddress: {
        messages: {
          label: defineMessage({
            id: "loyaltyOrganization.emailAddress",
            defaultMessage: "emailAddress",
          }),
        },
      },
      location: {
        hideTitle: true,
        children: {
          __fieldOrder: ["address", "zipCode", "city", "country", "*"],
          country: {
            widget: CountrySelector,
            messages: {
              label: defineMessage({ id: "loyaltyCustomer.country", defaultMessage: "country" }),
            },
          },
          city: {
            messages: {
              label: defineMessage({ id: "loyaltyCustomer.city", defaultMessage: "city" }),
            },
          },
          address: {
            messages: {
              label: defineMessage({ id: "loyaltyCustomer.address", defaultMessage: "address" }),
            },
          },
          zipCode: {
            messages: {
              label: defineMessage({ id: "loyaltyCustomer.zipCode", defaultMessage: "zipCode" }),
            },
          },
        },
      },
      tagsList: {
        fieldWidget: ArrayAsString,
        messages: {
          label: defineMessage({
            id: "loyaltyOrganization.tagsList",
            defaultMessage: "tagsList",
          }),
          helpText: defineMessage({
            id: "loyaltyOrganization.tagsListHelpText",
            defaultMessage: "HelpText",
          }),
        },
      },
      tiersList: {
        fieldWidget: LoyaltyConstantTierSelectorMulti,
        messages: {
          label: defineMessage({
            id: "loyaltyOrganization.tiersList",
            defaultMessage: "tiersList",
          }),
          helpText: defineMessage({
            id: "loyaltyOrganization.tiersListHelpText",
            defaultMessage: "HelpText",
          }),
        },
      },
    }),
    []
  );

  const OrganizationTypeRenderer = useCallback(
    ({ value, config, button, rows }: RendererProps<{ organizationType?: string } | undefined>) => {
      return (
        <div>
          {value?.organizationType === ORGANIZATION_TYPE.AGENCY ? (
            <FormattedMessage {...messages.agency} />
          ) : (
            <FormattedMessage {...messages.company} />
          )}
        </div>
      );
    },
    []
  );

  const tableColumns: TableColumns<OrganizationWithType> = {
    ticker: {
      renderer: TableRenderers.StringRenderer,
      width: 100,
    },
    organizationType: {
      renderer: OrganizationTypeRenderer,
      width: 80,
    },
    name: {
      renderer: TableRenderers.StringRenderer,
      width: 100,
    },
    legalIdentifier: {
      renderer: TableRenderers.StringRenderer,
      width: 100,
    },
    iata: {
      renderer: ({
        value: _value,
        config: rendererConfig,
        button,
        rows,
      }: RendererProps<string | undefined>) => {
        return TableRenderers.StringRenderer({
          value: rows?.agency?.iata || "",
          config: rendererConfig,
          button,
          rows,
        });
      },
      width: 80,
    },
    phoneNumber: {
      renderer: TableRenderers.StringRenderer,
      width: 100,
    },
    emailAddress: {
      renderer: TableRenderers.StringRenderer,
      width: 200,
    },
    tagsList: {
      renderer: mapRenderer(StringRenderer, (v, intl) => {
        if (!v || !v.length) {
          return undefined;
        }
        return v.toString();
      }),
      width: 200,
    },
    tiersList: {
      renderer: TierListRenderer,
      width: 200,
    },
    location: {
      children: {
        country: {
          renderer: TableRenderers.mapRenderer(TableRenderers.StringRenderer, v => {
            return v?.country;
          }),
          width: 60,
        },
        city: {
          renderer: TableRenderers.mapRenderer(TableRenderers.StringRenderer, v => {
            return v?.city;
          }),
          width: 100,
        },
        address: {
          renderer: TableRenderers.mapRenderer(TableRenderers.StringRenderer, v => {
            return v?.address;
          }),
          width: 100,
        },
        zipCode: {
          renderer: TableRenderers.mapRenderer(TableRenderers.StringRenderer, v => {
            return v?.zipCode;
          }),
          width: 100,
        },
      },
    },
  };

  const goToUserList = useCallback(
    async companyTicker => {
      const filters = JSON.parse(window.localStorage.getItem("asyncFilterValues") || "") || {};

      if (filters.customers) {
        filters.customers.organizationsList = companyTicker;
      } else {
        filters.customers = { organizationsList: companyTicker };
      }

      await window.localStorage.setItem("asyncFilterValues", JSON.stringify(filters));
      history.push(`loyalty-customers`);
    },
    [history]
  );
  const handleRegister = useCallback(
    (row, brand, constantTiers) => {
      let registrationURL =
        `https://${authorizationServiceDomain}/auth/realms/${brand}/protocol/openid-connect/registrations` +
        `?response_type=code&client_id=engine` +
        `&scope=openid` +
        `&redirect_uri=https://${loyaltyDomain}/api/loyalty/${brand}/${propertyTicker}/session` +
        `&property_ticker=${propertyTicker}` +
        `&ui_locales=${locale}` +
        `&organizationId=${row.id}`;

      let tiers = row?.tiersList.map((tierId: string) => {
        return {
          url: `${registrationURL}&tierId=${tierId}`,
          tierTicker: constantTiers?.find(
            (it: LoyaltyConstantTier.AsObject) => it?.externalSystemId === tierId
          )?.ticker,
        };
      });
      tiers = tiers.map((tier: { url: string; urlShort: string; tierTicker: string }) => ({
        ...tier,
        urlShort: tier?.url.substring(0, 64) + "[...]" + tier?.url.substring(64, 128),
      }));
      const organization = row?.ticker;
      setRegisterModalParams({ organization, tiers });
      setModalOpen(true);
    },
    [authorizationServiceDomain, loyaltyDomain, propertyTicker, locale]
  );

  const TableRowActions = useCallback(
    ({ row, rest }: DefaultTableRowActionsProps<Organization.AsObject>) => {
      return (
        <Table.Cell {...rest}>
          <StyledReactTooltip id="edit" effect="solid">
            <FormattedMessage {...organizationMessages.edit} />
          </StyledReactTooltip>
          <StyledReactTooltip id="customers" effect="solid">
            <FormattedMessage {...organizationMessages.customers} />
          </StyledReactTooltip>
          <StyledReactTooltip id="register" effect="solid">
            <FormattedMessage {...organizationMessages.register} />
          </StyledReactTooltip>
          <Edit onGoToEdit={id => history.push(`${match.url}/edit/${id}`)} row={row} />
          <Button
            disabled={false}
            data-tip="React-tooltip"
            data-for="customers"
            size="sm"
            className="mr-2"
            variant="light"
            onClick={() => goToUserList(row?.ticker)}>
            <FontAwesomeIcon icon={faUsers} />
          </Button>
          <Button
            disabled={false}
            data-tip="React-tooltip"
            data-for="register"
            size="sm"
            className="mr-2"
            variant="light"
            onClick={() => handleRegister(row, brand, constantTiers)}>
            <FontAwesomeIcon icon={faLink} />
          </Button>
        </Table.Cell>
      );
    },
    [match, history, brand, constantTiers, goToUserList, handleRegister]
  );

  const handleHideModal = useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);

  const handleCopy = useCallback(url => {
    navigator.clipboard.writeText(url);
  }, []);

  // not using translations for managerName because filter storage won't work on language change
  return (
    <>
      {registerModalParams && (
        <Modal show={modalOpen} onHide={() => handleHideModal()}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            {registerModalParams.tiers.map(tier => (
              <Tier>
                <div>
                  <FormattedMessage {...messages.modalText1} />{" "}
                  <span> {registerModalParams.organization}</span>{" "}
                  <FormattedMessage {...messages.modalText2} /> <span>{tier.tierTicker}</span>:
                </div>
                <a href={tier.url}>{tier.urlShort}</a>
                <Copy onClick={() => handleCopy(tier.url)}>
                  <FormattedMessage {...messages.copy} />
                </Copy>
              </Tier>
            ))}
          </Modal.Body>
        </Modal>
      )}
      {brand && (
        <SimpleCrud<OrganizationWithType, OrganizationFilters>
          schema={modifiedSchema}
          formConfiguration={formConfiguration}
          tableColumns={tableColumns}
          tableFilters={tableFilters}
          formContainer={FormContainer}
          messages={messages}
          onGetAll={onGetAll}
          onGetOne={onGetOne}
          columnVisibility={true}
          onCreate={onCreate}
          canCreate={actions.CreateLoyaltyCustomers}
          columnVisibilityExtensions={columnVisibilityExtensions}
          managerName={"organizations"}
          CSVRenderers={CSVRenderers}
          onUpdate={onUpdate}
          section={SECTION.LOYALTY_CUSTOMERS || SECTION.LOYALTY_ORGANIZATIONS}
          rowActions={props => <TableRowActions {...props} />}
          paging={true}
          defaultPageSize={defaultPageSize}
          pageSizes={pageSizes}
        />
      )}
    </>
  );
}

export default withAuthorizationVerifier(LoyaltyOrganizationCrud);
